
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaiairporttopuneinnovacabs() {



    const cardData =
    {
        keyword: 'Mumbai Airport to Pune Innova Cabs Services',
        heading: 'S9 Travels: Mumbai Airport to Pune Innova Cabs Services',
        headingDescription: 'S9 Travels offers premium Innova cab services for travelers going from Mumbai Airport to Pune. Whether you’re heading home, going for a business trip, or simply need a comfortable ride, our fleet of well-maintained Innovas provides a safe, reliable, and luxurious travel experience. The distance between Mumbai Airport and Pune is approximately 150 km, and the journey typically takes around 3 to 3.5 hours by road.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historical fortification in Pune, originally built in the 18th century. The fort was the seat of the Peshwa rulers and is a popular tourist spot known for its grandeur, architecture, and the iconic gates. It's an excellent place to learn about Pune’s royal past."
    },
    {
      "title": "Aga Khan Palace",
      "description": "The Aga Khan Palace is a beautiful historical site and a prominent landmark in Pune. Built in 1892, it is also famous for being the place where Mahatma Gandhi and his followers were imprisoned during the Quit India Movement. The palace and its gardens offer a peaceful retreat."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located on a hilltop about 30 km from Pune, Sinhagad Fort offers breathtaking views of the surrounding valleys. It’s a popular spot for trekking and history enthusiasts, offering insight into Maratha history and an opportunity to enjoy nature and local food at the top."
    },
    {
      "title": "Osho Ashram",
      "description": "Osho Ashram is an international spiritual center located in the heart of Pune. It attracts visitors from around the world for meditation, yoga, and spiritual growth. The serene atmosphere and lush green surroundings make it an ideal place for relaxation and reflection."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "The Pataleshwar Cave Temple, located in the heart of Pune, is an ancient rock-cut temple dedicated to Lord Shiva. The temple, carved out of a single rock, is an architectural marvel and provides a peaceful environment for devotees and visitors alike."
    },
    {
      "title": "Shinde Chhatri",
      "description": "Shinde Chhatri is a memorial dedicated to Mahadji Shinde, a Maratha general. Located near the Wanowrie area, it is a beautiful structure with intricate carvings and serene surroundings. The memorial also features a temple dedicated to Lord Shiva."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "The Pune Okayama Friendship Garden is a Japanese-style garden located in the heart of Pune. Inspired by the famous Korakuen Garden in Okayama, Japan, this garden offers beautiful landscapes, water bodies, and lush greenery, making it a perfect place for a relaxing day out."
    },
    {
      "title": "Rajiv Gandhi Zoological Park",
      "description": "For nature and animal lovers, the Rajiv Gandhi Zoological Park is a must-visit. The zoo houses a variety of animals, birds, and reptiles in well-maintained habitats. It also includes a snake park and a lake, offering a great experience for families and wildlife enthusiasts."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "The Dagdusheth Halwai Ganpati Temple is one of Pune’s most famous temples, dedicated to Lord Ganesha. It is known for its grand celebrations during Ganesh Chaturthi and its stunning architecture. The temple is a place of devotion, peace, and vibrant festivities."
    },
    {
      "title": "Mulshi Lake and Dam",
      "description": "Mulshi Lake and Dam is a popular weekend getaway from Pune, offering scenic views of the surrounding hills and lush greenery. The area is perfect for nature lovers and those seeking a peaceful retreat, with opportunities for photography, boating, and picnics."
    }
],

"services": [
    {
      "name": "Mumbai Airport to Pune Innova Taxi Service",
      "description": "Looking for a comfortable and reliable way to travel from Mumbai Airport to Pune? Book an Innova taxi for a smooth and hassle-free ride. Our Innova cabs provide ample space for passengers and luggage, making it a perfect choice for families, groups, and business travelers."
    },
    {
      "name": "Mumbai Airport to Pune Innova Cab Service",
      "description": "Our Innova cabs offer a top-quality ride from Mumbai Airport to Pune, ensuring a safe, comfortable, and punctual journey. With experienced drivers, modern vehicles, and premium comfort, our service is designed to make your travel easy and stress-free."
    },
    {
      "name": "Book Innova Cab for Mumbai to Pune",
      "description": "Book an Innova cab for your Mumbai to Pune trip and enjoy a comfortable journey. Whether you are traveling alone, with a family, or in a group, our Innova taxis offer the perfect blend of comfort and space for everyone."
    },
    {
      "name": "Mumbai to Pune Innova Car Rental",
      "description": "Looking to rent an Innova for your Mumbai to Pune journey? We offer flexible Innova car rental services, where you can book the vehicle for one-way trips, round trips, or multi-day rentals. Get your Innova car at the most competitive prices."
    },
    {
      "name": "Mumbai to Pune One-Way Innova",
      "description": "Planning a one-way trip from Mumbai to Pune? Book an Innova for a one-way ride. With our one-way Innova taxi, you can travel directly from Mumbai Airport to Pune in comfort. Choose from luxury or affordable options based on your budget."
    },
    {
      "name": "Mumbai to Pune Round Trip Innova Cab",
      "description": "Traveling for business or leisure? Book an Innova round-trip for your Mumbai to Pune journey. Our round-trip services are flexible, and we’ll ensure that your journey back is just as comfortable and reliable as the ride to your destination."
    },
    {
      "name": "Mumbai to Pune Innova Cab Booking",
      "description": "Booking an Innova cab for your Mumbai to Pune trip is easy and hassle-free. You can book your Innova taxi online, ensuring a guaranteed vehicle and professional driver. Choose the vehicle that suits your needs and schedule."
    },
    {
      "name": "Affordable Innova Taxi for Mumbai to Pune",
      "description": "Looking for a budget-friendly Innova taxi? We offer affordable rates for Mumbai to Pune travel. Get the perfect balance of comfort and price when you book an Innova for your next trip."
    },
    {
      "name": "Mumbai to Pune One-Way Taxi",
      "description": "If you are traveling one-way from Mumbai to Pune, book an Innova taxi for the most convenient ride. Our one-way taxi service allows you to enjoy a direct transfer without the hassle of multiple stops. Enjoy comfort, luxury, and space with our Innova cabs."
    },
    {
      "name": "Innova Service from Mumbai Airport to Pune",
      "description": "Our Innova service from Mumbai Airport to Pune is tailored for passengers who want a premium and reliable ride. With comfortable seating and ample space for luggage, our Innova cabs are perfect for your airport transfer."
    },
    {
      "name": "Group Travel from Mumbai Airport to Pune",
      "description": "If you’re traveling with a group, our Innova cabs are the perfect solution. With the capacity to accommodate 6-7 passengers comfortably, our Innova taxis are ideal for group travel from Mumbai Airport to Pune."
    },
    {
      "name": "Mumbai to Pune Luxury Innova",
      "description": "For those seeking a more luxurious travel experience, book our luxury Innova for your Mumbai to Pune journey. Equipped with premium amenities, luxury Innova cabs offer a high-end experience with comfort and style."
    },
    {
      "name": "Innova Cabs for Mumbai-Pune Airport Transfer",
      "description": "Book Innova cabs for your Mumbai-Pune Airport transfer and enjoy a smooth, seamless ride. Whether you’re arriving or departing, we provide private Innova taxis for airport transfers, ensuring timely arrivals and departures with no hassle."
    },
    {
      "name": "Private Innova for Mumbai-Pune",
      "description": "For a private, personalized ride between Mumbai and Pune, book an Innova cab. Enjoy the privacy and comfort of a dedicated driver while traveling between the two cities. This is a great option for those who want a more exclusive, tailored experience."
    }
  ],

"tableData": [
  ["Mumbai Airport to Pune Innova Taxi", "Mumbai Airport to Pune Innova Cab Service"],
  ["Book Innova Cab for Mumbai to Pune", "Mumbai to Pune Innova Car Rental"],
  ["Mumbai to Pune One-Way Innova", "Mumbai to Pune Round Trip Innova Cab"],
  ["Mumbai to Pune Innova Cab Booking", "Affordable Innova Taxi for Mumbai to Pune"],
  ["Mumbai to Pune One-Way Taxi", "Innova Service from Mumbai Airport to Pune"],
  ["Group Travel from Mumbai Airport to Pune", "Mumbai to Pune Luxury Innova"],
  ["Innova Cabs for Mumbai-Pune Airport Transfer", "Private Innova for Mumbai-Pune"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of timely arrivals when traveling from Mumbai Airport to Pune. Our drivers ensure prompt pickups, ensuring that you have enough time to relax and prepare for your journey, whether you’re heading home after a flight or catching a meeting."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are perfect for long-distance journeys like Mumbai Airport to Pune. With spacious interiors, air conditioning, and ample legroom, you’ll experience a smooth and relaxing ride. Whether you're traveling alone, with family, or in a group, our Innova ensures a comfortable journey every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and well-trained to handle long-distance trips. They are familiar with the best routes from Mumbai Airport to Pune and are dedicated to ensuring a safe and smooth journey. Their professionalism and courteous nature provide a stress-free travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai Airport to Pune Innova ride. We ensure there are no hidden charges, and you’ll receive a clear breakdown of all costs upfront, allowing you to manage your travel expenses effectively."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our Toyota Innova cabs are equipped with modern safety features such as airbags, seat belts, and GPS tracking. We make sure that your journey from Mumbai Airport to Pune is as secure and comfortable as possible."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available 24/7, so whether your flight lands early in the morning or late at night, we’ll be there to pick you up on time. Our customer service team is always available to assist with any last-minute changes or requests, ensuring you have a seamless experience."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai Airport to Pune Innova cab is quick and easy with S9 Travels. You can book online through our website or mobile app, or contact our customer service team for personalized assistance with your booking. We make it simple to plan your airport transfer."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer flexible and customized travel options for your trip from Mumbai Airport to Pune. If you require extra stops along the way or have specific requests, we can tailor the trip to suit your needs, ensuring a personalized and hassle-free experience."
  }
]























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova cab for Mumbai Airport to Pune with S9 Travels?',
            answer: 'You can easily book your Innova cab online via our website or mobile app. For any special requirements or assistance, feel free to contact our customer service team.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova comfortably seats up to 6 passengers, making it ideal for family groups, business travelers, or anyone with a lot of luggage.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Mumbai Airport to Pune?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes from Mumbai Airport to Pune. They ensure a smooth, timely, and safe journey for all passengers.',
          },
          {
            question: 'What payment options are available for booking an Innova for Mumbai Airport to Pune?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments through our app, allowing you to pay in the most convenient way.',
          },
          {
            question: 'Can I book a round trip from Mumbai Airport to Pune?',
            answer: 'Yes, we can arrange a round-trip booking. Just provide us with your return details, and we’ll ensure your ride back to Mumbai or Pune is just as comfortable and timely.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any additional charges, such as for waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I make extra stops during the journey from Mumbai Airport to Pune?',
            answer: 'Yes, if you need to make additional stops or detours, please inform us during the booking process, and we’ll be happy to accommodate your requests.',
          },
          {
            question: 'What is the luggage allowance for an Innova cab?',
            answer: 'The Toyota Innova provides ample space for standard luggage. If you have more luggage or specific requirements, please let us know when booking, and we’ll ensure your needs are met.',
          },
          {
            question: 'Is S9 Travels available for corporate travel from Mumbai Airport to Pune?',
            answer: 'Yes, we offer corporate travel services for individuals or groups traveling between Mumbai Airport and Pune. We ensure a comfortable, professional, and timely experience for all passengers.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai Airport to Pune Innova cab booking?',
            answer: 'S9 Travels offers reliable, safe, and comfortable transport, with professional drivers, well-maintained vehicles, and transparent pricing. We guarantee a smooth, stress-free journey from Mumbai Airport to Pune every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Amit Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I had a great experience with S9 Travels. The Innova was spacious and comfortable, and the driver was punctual. He ensured a smooth ride from Mumbai Airport to Pune. Highly recommended for airport transfers!”',
        },
        {
          name: 'Mrs. Snehal Patil',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“S9 Travels made my airport transfer from Mumbai Airport to Pune so easy. The vehicle was clean, and the driver was very professional. I reached home on time and relaxed after my long flight. Great service!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Airport to Pune Innova Cabs",
        "description": "Book Innova cabs from Mumbai Airport to Pune with S9 Travels. Offering affordable, luxury, and private Innova taxi services for one-way, round-trip, and group travel from Mumbai to Pune. Enjoy a comfortable and safe ride with professional drivers.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "1200"
        }
      };
      
    
      
      


    return (
        <div>
           <Helmet>
        <title>Mumbai Airport to Pune Innova Cabs | Luxury & Affordable Mumbai to Pune Taxi Service | S9 Travels</title>
        <meta 
          name="description" 
          content="Book an Innova cab from Mumbai Airport to Pune. Affordable one-way and round-trip taxi services with luxury and comfort. Book now for private and group travel from Mumbai to Pune, including airport transfer services." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopuneinnovacabs;